<template>
    <div id="duration">
        <div class="material-icons time-icon">timelapse</div>
        <div class="content">
            <span class="time-label">{{ $t("calendar.generalAvailability") }}</span>
            <span class="time-sub-label">{{ $t("calendar.generalAvailabilityDesc") }}</span>
            <a-select v-model="duration" show-search class="time-select">
                <a-select-option v-for="(remindDate, index) of remindDates" :key="index" :value="remindDate.value">
                    {{ remindDate.label }}
                </a-select-option>
            </a-select>
        </div>
        <Modal2
            id="duration-modal"
            v-if="showModal"
            :showTitle="false"
            :show-footer="false"
            @cancel="showModal = false"
            style="width: 50vw"
        >
            <div class="new-form-item">{{ $t("calendar.customDuration") }}</div>
            <div>
                <input class="input-number" type="number" v-model="customDuration" min="1" />
                <a-select class="select-item" v-model="selectedType">
                    <a-select-option :value="type.value" v-for="(type, i) in types" :key="i">
                        {{ type.label }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="footer">
                <span class="footer-btn" @click="showModal = false">{{ $t("message.cancel") }}</span>
                <span class="footer-btn" @click="saveCustomDuration()">{{ $t("message.save") }}</span>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import _ from "lodash";
import Modal2 from "../../../../../components/common/Modal2.vue";

const log = log2("Duration");
export default {
    name: "Duration",
    components: { Modal2 },
    props: {
        value: {
            type: Number,
            default: 15,
        },
    },
    data() {
        return {
            remindDates: [
                {
                    value: 15,
                    label: `15 ${this.$t("report.minute")} `,
                },
                {
                    value: 30,
                    label: `30 ${this.$t("report.minute")} `,
                },
                {
                    value: 45,
                    label: `45 ${this.$t("report.minute")} `,
                },
                {
                    value: 60,
                    label: `1 ${this.$t("report.hour")} `,
                },
                {
                    value: 90,
                    label: `1.5 ${this.$t("report.hour")} `,
                },
                {
                    isCustom: true,
                    value: 120,
                    label: `120 ${this.$t("report.minute")} `,
                },
                { value: "custom", label: this.$t("calendar.customize") },
            ],
            types: [
                { value: "minutes", label: "minutes" },
                { value: "hours", label: "hours" },
            ],
            duration: _.clone(this.value),
            selectedType: "minutes",
            showModal: false,
            customDuration: 15,
        };
    },
    methods: {
        saveCustomDuration() {
            this.remindDates.map((x) => {
                if (x.isCustom) {
                    x.value = Number(this.customDuration);
                    x.label =
                        (this.selectedType === "hours" ? this.customDuration * 60 : this.customDuration) + " dakika";
                }
                return x;
            });
            this.duration =
                this.selectedType === "hours" ? Number(this.customDuration * 60) : Number(this.customDuration);
            this.showModal = false;
        },
    },
    async mounted() {},
    beforeDestroy() {},
    watch: {
        duration(val) {
            if (val === "custom") {
                this.showModal = true;
            } else this.$emit("input", val);
        },
    },
};
</script>

<style lang="scss">
#duration-modal {
    .ant-model-content {
        width: 300px;
        display: grid;
        justify-content: center;
    }

    .input-number {
        margin-right: 10px;
        border: none;
        background-color: #e3e3e3;
        border-radius: 5px;
        height: 35px;
        width: 60px;
        padding: 10px;
    }

    .footer {
        display: flex;
        justify-content: end;

        .footer-btn {
            background-color: #4776b3;
            color: white;
            padding: 1px 10px;
            border-radius: 10px;
            margin-right: 20px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
        }
    }
}
</style>

<style lang="scss" scoped>
#duration {
    display: flex;
    flex-direction: row;

    .time-icon {
        margin-top: 2px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        display: flex;
        flex-direction: column;

        .time-label {
            color: black;
            font-weight: 500;
            font-size: 16px;
        }

        .time-sub-label {
            font-size: 12px;
        }

        .time-select {
        }
    }
}
</style>
